import script from "./AdminProductAddView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminProductAddView.vue?vue&type=script&setup=true&lang=js"

import "./AdminProductAddView.vue?vue&type=style&index=0&id=715934ea&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-715934ea"]])

export default __exports__